<template>
  <h1 class="w-full text-2xl sm:text-3xl font-bold text-center sm:px-20 mb-8">
    {{ $t(`${trPrefix}signInTitle`) }}
  </h1>
  <WebccForm ref="formRef" v-model="formdata" class="w-full" @submit="submit">
    <WebccInput
      v-model="email"
      class="mb-4"
      name="email"
      :label="$t(`${trPrefix}email`)"
      type="email"
      :valid="fieldsValid"
    />
    <WebccInput
      v-model="password"
      class="mb-2"
      name="password"
      :label="$t(`${trPrefix}password`)"
      type="password"
      :valid="fieldsValid"
    />
    <div class="w-full text-right">
      <span
        class="text-sm text-txt-weak hover:underline cursor-pointer"
        @click="goToForgotPassword"
      >
        {{ $t(`${trPrefix}forgotPassword`) }}
      </span>
    </div>
    <WebccFeedbackMessage
      v-if="errorMessage"
      :message="errorMessage"
      type="error"
      class="my-4"
    />
    <WebccButton class="my-4 w-full" variant="theme" size="lg" :loading
      >{{ $t(`${trPrefix}signIn`) }}
    </WebccButton>
  </WebccForm>

  <UserAgreement class="mb-8" />

  <WebccOrDivider :with-text="true" class="mb-6" />

  <SocialSignIns class="mb-6" />

  <span class="text-xl mt-auto text-center">
    {{ $t(`${trPrefix}newToIH`) }}
    <span
      class="text-thm hover:underline font-bold hover:cursor-pointer"
      @click="goToSignup"
    >
      {{ $t(`${trPrefix}register`) }}
    </span>
  </span>
</template>

<script lang="ts" setup>
const trPrefix = 'components.auth.login.loginForm.'

const emit = defineEmits<{
  goTo: [value: AuthFlow]
  isReady: []
}>()

const { getErrorMessage } = useAuthError(trPrefix)
const route = useRoute()
const auth = useAuthStore()
const authModalEvt = useEventBus<AuthState>('authModal')
const tracking = useTracking()

const email = ref('')
const password = ref('')
const fieldsValid = ref<boolean>()
const formdata = ref({ email: '' })
const loading = ref(false)
const errorMessage = ref<string>()

onMounted(() => {
  emit('isReady')
})

await initLoginFlow()

async function initLoginFlow() {
  if (!import.meta.client) return

  try {
    await auth.loginStart(route.fullPath)
  } catch (error) {
    errorMessage.value = getErrorMessage(error)
  }
}

async function submit() {
  try {
    loading.value = true

    await auth.loginWithPassword(email.value, password.value)

    tracking.handlers?.auth.login()
    authModalEvt.emit({ status: false })
  } catch (error) {
    errorMessage.value = getErrorMessage(error)
    fieldsValid.value = false
  } finally {
    loading.value = false
  }
}

function goToSignup() {
  emit('goTo', 'signUp')
}

function goToForgotPassword() {
  emit('goTo', 'forgotPassword')
}

watch([email, password], () => {
  fieldsValid.value = undefined
  errorMessage.value = undefined
})
</script>
